<div class="highlight-container">
    <div class="highlight-content container">
        <div class="top-section">
            <p class="highlight-title font-poppins">Why Choose Our Toys?</p>
            <p class="highlight-subtitle">Quality, safety, emotion, stories, memories and meanings in every block</p>
        </div>
        <div class="bottom-section">
            <div class="section">
                <div class="icon-container">
                    <mat-icon [svgIcon]="'safematerial'" class="quality-icon green-color"></mat-icon>
                </div>
                <div class="section-content">
                    <p class="section-title font-poppins">Safe Materials</p>
                    <p class="section-subtitle">Non-toxic, BPA - free materials tested for child safety standards</p>
                </div>
            </div>

            <div class="section">
                <div class="icon-container">
                    <mat-icon [svgIcon]="'bulb'" class="quality-icon yellow-color"></mat-icon>
                </div>

                <div class="section-content">
                    <p class="section-title font-poppins">Beyond Possibility</p>
                    <p class="section-subtitle">
                        Design, build, and express without limits - dream freely, build with a purpose and rediscover
                        creative calm.
                    </p>
                </div>
            </div>

            <div class="section">
                <div class="icon-container">
                    <mat-icon [svgIcon]="'color'" class="quality-icon pink-color"></mat-icon>
                </div>

                <div class="section-content">
                    <p class="section-title font-poppins">Story-rich colors</p>
                    <p class="section-subtitle">
                        Vibrant hues that carry emotion - awakening visual development and sparking imagination
                    </p>
                </div>
            </div>

            <div class="section">
                <div class="icon-container">
                    <mat-icon [svgIcon]="'age'" class="quality-icon blue-color"></mat-icon>
                </div>

                <div class="section-content">
                    <p class="section-title font-poppins">Made for Every Age</p>
                    <p class="section-subtitle">
                        From first builds to lifelong creativity - designed to create moments, memories, and meaning,
                        block by block, generation by generation.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
